import _ from 'lodash';

export function getPlotOptions(chartDef, data, pointWidth, opacity) {
    if (!chartDef) return null;
    const { stacking, allowLegendItemClick } = chartDef;
    const legendClickHandler = (event) => {
        const series = event.target;

        if (allowLegendItemClick === false) {
            event.preventDefault();
            return false;
        }

        // Only check if the clicked series is currently visible.  A click when the series is hidden will show the
        // series, which we don't want to prevent.
        if (series.options.visible !== false) {
            // Filter the chart series array to only the visible series.
            if (_.filter(series.chart.series, (s) => s.options.visible !== false).length <= 1) {
                // Only one series is currently visible, so prevent it from being hidden.
                event.preventDefault();
                return false;
            }
        }

        return true;
    };

    return _.merge(
        {
            area: {
                lineWidth: 0,
                marker: {
                    radius: 0,
                    states: {
                        hover: {
                            radius: 4,
                            radiusPlus: 0,
                        },
                    },
                    symbol: 'circle',
                },
                stacking,
                states: {
                    hover: {
                        lineWidthPlus: 0,
                    },
                },
            },
            areaspline: {
                lineWidth: 0,
                marker: {
                    radius: 0,
                    states: {
                        hover: {
                            radius: 4,
                            radiusPlus: 0,
                        },
                    },
                    symbol: 'circle',
                },
                stacking,
                states: {
                    hover: {
                        lineWidthPlus: 0,
                    },
                },
            },
            column: {
                borderWidth: 0,
                pointWidth,
                groupPadding: 0,
                pointPlacement: 'between',
                pointPadding: 0,
                opacity,
                stacking,
                states: {
                    hover: {
                        brightness: 0,
                    },
                },
            },
            line: {
                lineWidth: 2,
                marker: {
                    radius: 0,
                    states: {
                        hover: {
                            radius: 4,
                            radiusPlus: 0,
                        },
                    },
                    symbol: 'circle',
                },
                stacking,
                states: {
                    hover: {
                        lineWidthPlus: 0,
                    },
                },
            },
            series: {
                animation: false,
                states: {
                    inactive: {
                        opacity: 1,
                    },
                },
                events: {
                    legendItemClick: legendClickHandler,
                },
            },
            spline: {
                lineWidth: 2,
                marker: {
                    radius: 0,
                    states: {
                        hover: {
                            radius: 4,
                            radiusPlus: 0,
                        },
                    },
                    symbol: 'circle',
                },
                stacking,
                states: {
                    hover: {
                        lineWidthPlus: 0,
                    },
                },
            },
        },
        chartDef.plotOptions || {}
    );
}
